/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { AggregateKeyInfo } from './AggregateKeyInfo';
import {
    AggregateKeyInfoFromJSON,
    AggregateKeyInfoFromJSONTyped,
    AggregateKeyInfoToJSON,
} from './AggregateKeyInfo';

/**
 * 
 * @export
 * @interface ContactLieuSearch
 */
export interface ContactLieuSearch {
    /**
     * 
     * @type {number}
     * @memberof ContactLieuSearch
     */
    idlieuFormation?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof ContactLieuSearch
     */
    sortKey?: Array<string> | null;
    /**
     * 
     * @type {Array<AggregateKeyInfo>}
     * @memberof ContactLieuSearch
     */
    aggregateKeys?: Array<AggregateKeyInfo> | null;
    /**
     * 
     * @type {number}
     * @memberof ContactLieuSearch
     */
    forceSkip?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ContactLieuSearch
     */
    forceTake?: number | null;
    /**
     * 
     * @type {any}
     * @memberof ContactLieuSearch
     */
    parameters?: any | null;
    /**
     * 
     * @type {string}
     * @memberof ContactLieuSearch
     */
    filter?: string | null;
}

/**
 * Check if a given object implements the ContactLieuSearch interface.
 */
export function instanceOfContactLieuSearch(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ContactLieuSearchFromJSON(json: any): ContactLieuSearch {
    return ContactLieuSearchFromJSONTyped(json, false);
}

export function ContactLieuSearchFromJSONTyped(json: any, ignoreDiscriminator: boolean): ContactLieuSearch {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'idlieuFormation': !exists(json, 'idlieuFormation') ? undefined : json['idlieuFormation'],
        'sortKey': !exists(json, 'sortKey') ? undefined : json['sortKey'],
        'aggregateKeys': !exists(json, 'aggregateKeys') ? undefined : (json['aggregateKeys'] === null ? null : (json['aggregateKeys'] as Array<any>).map(AggregateKeyInfoFromJSON)),
        'forceSkip': !exists(json, 'forceSkip') ? undefined : json['forceSkip'],
        'forceTake': !exists(json, 'forceTake') ? undefined : json['forceTake'],
        'parameters': !exists(json, 'parameters') ? undefined : json['parameters'],
        'filter': !exists(json, 'filter') ? undefined : json['filter'],
    };
}

export function ContactLieuSearchToJSON(value?: ContactLieuSearch | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'idlieuFormation': value.idlieuFormation,
        'sortKey': value.sortKey,
        'aggregateKeys': value.aggregateKeys === undefined ? undefined : (value.aggregateKeys === null ? null : (value.aggregateKeys as Array<any>).map(AggregateKeyInfoToJSON)),
        'forceSkip': value.forceSkip,
        'forceTake': value.forceTake,
        'parameters': value.parameters,
        'filter': value.filter,
    };
}

